import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Dolor de rodilla que aparece siempre al km 20', '$80.000 por salida al taller para cosas que podrías hacer vos', 'El grupo acelera en la subida y te quedás para atrás sin entender por qué', 'Geles importados a $5.000 cada uno que se comen el presupuesto del mes', 'Entrenás 3 veces por semana pero hace 12 meses que los tiempos no mejoran'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-265">
      <FadeIn data-id="element-266">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2 text-[#0f172a]" data-id="element-267">
          ¿Cuántos kilómetros más vas a pedalear así?
        </h2>

        <div className="text-sm md:text-xl text-[#475569] text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto font-medium" data-id="element-268">
          <p data-id="element-269">
            Dolor de rodilla que vuelve siempre. Plata que se va al taller.
            Grupo que te deja en cada subida.
          </p>
          <p className="font-bold text-[#0f172a] text-lg md:text-2xl mt-4 md:mt-8" data-id="element-270">
            No es falta de piernas.{' '}
            <span className="text-[#ef4444]" data-id="element-271">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-272">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-273">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: '#f8fafc'
        }} className="bg-white border border-[#e2e8f0] rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors shadow-sm" data-id="element-274">
              <XCircle className="text-[#ef4444] shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-275" />
              <span className="text-sm md:text-lg text-[#0f172a] leading-relaxed font-medium" data-id="element-276">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-277">
        <div className="text-center relative" data-id="element-278">
          <div className="absolute inset-0 bg-[#22c55e]/10 blur-3xl rounded-full" data-id="element-279"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-280">
            <Sparkles className="text-[#22c55e] mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-281" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#16a34a] via-[#22c55e] to-[#4ade80] drop-shadow-sm px-2" data-id="element-282">
              ¿Y si esta fuera la última salida que terminaste así?
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}